<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-25T15:08:56+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe - Not found page
@Last modified by:   tom
@Last modified time: 2018-01-19T18:11:01+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved
-->

<template>
  <c-page
    id="notfound"
    :title="$t('not_found.title') "
    sideimage="@/assets/img/aboutus/consultant-work.jpg"
  />
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
  #notfound {
    margin: 100px 20px;
  }
</style>
